import PropTypes from "prop-types";
import React from "react";
import { Switch, Route } from "react-router-dom";

import { TabPanel } from "../../../../components";
import { ROLES } from "../../../../Constants";
import { withUserRole } from "../../../../Utils";
import ReferralDetails from "../../../../Referrals/ReferralDetails";

import CaseDetail from "../CaseDetail";

import EditMatter from "./EditMatter";
import MattersListing from "./MattersListing";

const Matters = ({ person, ...props }) => (
  <TabPanel>
    <Switch>
      <Route
        exact
        path="/people/:person/matters"
        component={(routeProps) => (
          <MattersListing person={person} {...props} {...routeProps} />
        )}
      />
      <Route
        path="/people/:person/matters/:id/referrals/:rid"
        component={(routeProps) => (
          <ReferralDetails person={person} {...props} {...routeProps} />
        )}
      />
      <Route
        exact
        path="/people/:person/matters/:id/edit"
        component={(routeProps) => (
          <EditMatter person={person} {...props} {...routeProps} />
        )}
      />
      <Route
        path="/people/:person/matters/:id"
        component={(routeProps) => (
          <CaseDetail person={person} {...props} {...routeProps} />
        )}
      />
    </Switch>
  </TabPanel>
);

Matters.propTypes = {
  person: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string,
    phone1: PropTypes.string,
    phone2: PropTypes.string,
    mobile: PropTypes.string,
    member_status: PropTypes.string,
    membership_number: PropTypes.string,
    age: PropTypes.number,
    enrolledBloodQuantum: PropTypes.string,
    otherBloodQuantum: PropTypes.string,
    totalBloodQuantum: PropTypes.string,
    activeMailingAddress: PropTypes.shape({
      street1: PropTypes.string,
      street2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
    }),
    residences: PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool,
        kind: PropTypes.string,
        street1: PropTypes.string,
        street2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zipCode: PropTypes.string,
      })
    ),
  }).isRequired,
};

Matters.defaultProps = {};

const wrappedWithUserRole = withUserRole(Matters, [ROLES.CIVIL_ATTORNEY]);

export default wrappedWithUserRole;
